import { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { useSetupTodo } from './useSetupTodo';
import { useTour } from './useTour';

export const useTourSetupSync = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const { isOpen: isTourOpen } = useTour();
  const { isSetupComplete, loading: isSetupLoading, initialLoad, dataReady } = useSetupTodo();

  const [isMinimized, setIsMinimized] = useState(false);
  
  // Tur durumunun bir önceki halini hatırlamak için ref kullanalım
  const prevIsTourOpenRef = useRef(isTourOpen);

  const isManuallyMinimized = () => {
    if (!user?.companyId) return false;
    return localStorage.getItem(`setupTodo_minimized_${user.companyId}`) === 'true';
  };

  useEffect(() => {
    // Veri hazır değilse hiçbir şey yapma
    if (!dataReady || initialLoad || isSetupLoading) return;

    const prevIsTourOpen = prevIsTourOpenRef.current;

    // Kural 1: Tur AÇILDIĞINDA (false -> true)
    // Rehberi otomatik olarak küçült
    if (!prevIsTourOpen && isTourOpen) {
      setIsMinimized(true);
    }

    // Kural 2: Tur KAPANDIĞINDA (true -> false)
    // Kurulum tamamlanmadıysa ve manuel küçültülmediyse rehberi geri aç
    if (prevIsTourOpen && !isTourOpen && !isSetupComplete && !isManuallyMinimized()) {
      setIsMinimized(false);
    }
    
    // Bir sonraki kontrol için mevcut tur durumunu hafızaya al
    prevIsTourOpenRef.current = isTourOpen;

  }, [isTourOpen, isSetupComplete, isSetupLoading, initialLoad, dataReady, user?.companyId]);


  const minimizeGuideAndSave = () => {
    setIsMinimized(true);
    if (user?.companyId) {
      localStorage.setItem(`setupTodo_minimized_${user.companyId}`, 'true');
    }
  };

  const restoreGuideAndSave = () => {
    setIsMinimized(false);
    if (user?.companyId) {
      localStorage.removeItem(`setupTodo_minimized_${user.companyId}`);
    }
  };

  // Nihai görünürlük durumunu hesapla - veri hazır değilse hiçbir şey gösterme
  const showGuide = dataReady && !initialLoad && !isSetupComplete && !isMinimized;
  const showMinimizedGuide = dataReady && !initialLoad && !isSetupComplete && isMinimized;

  return {
    showGuide,
    showMinimizedGuide,
    minimizeGuideAndSave,
    restoreGuideAndSave,
  };
};
